export namespace PermitUserActions {
    export class GetCurrentPerson {
        public static readonly type = "[PermitUserActions] GetCurrentPerson";
    }

    export class GetPermitsToSign {
        public static readonly type = "[PermitUserActions] GetPermitsToSign";
    }

    export class GetPermitRequests {
        public static readonly type = "[PermitUserActions] GetPermitRequests";
    }

    export class GetPermitRequestCandidates {
        public static readonly type = "[PermitUserActions] GetPermitRequestCandidates";
        constructor(public permitId: number) {}
    }

    export class SelectPermitRequestCandidate {
        public static readonly type = "[PermitUserActions] SelectPermitRequestCandidate";
        constructor(public personId: number) {}
    }

    export class RequestPermit {
        public static readonly type = "[PermitUserActions] RequestPermit";
        constructor(public permitId: number) {}
    }

    export class ResetPermitRequestFlow {
        public static readonly type = "[PermitUserActions] ResetPermitRequestFlow";
    }
}
